export default [
  {
    static: true,
    name: 'name',
    type: 'Text',
    description: 'Max. length 255 characters.',
  },
  {
    static: true,
    name: 'phone',
    type: 'Phone (E.164)',
    description: 'Valid phone format: +442071838750',
  },
];
